module.exports = __webpack_public_path__ + "img/img19.1cee29f6.svg";